/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterDataSourceKind = (typeof FilterDataSourceKind)[keyof typeof FilterDataSourceKind];

export const FilterDataSourceKind = {
  data_source: 'data_source',
} as const;
